import React, { useEffect, useState } from 'react'

import { Slider, withFormikSupport } from '@fourthwall/components'

import { Label } from '../../components/Label/Label'
import * as S from './Range.styled'
import type { Props } from './types'

export const RangeComponent = ({ data, value, onChange, onSettingUpdate }: Props) => {
  const { id, label, min, max, step, value: initialValue, info, unit } = data

  const [lastValue, setLastValue] = useState(initialValue)

  useEffect(() => {
    if (lastValue === initialValue) return

    onSettingUpdate(id, lastValue, true)
  }, [lastValue])

  return (
    <>
      <Label info={info}>{label}</Label>
      <S.Container>
        <S.SliderContainer>
          <Slider
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={(value) => {
              onChange(value)
            }}
            onChangeComplete={(value) => setLastValue(value)}
          />
        </S.SliderContainer>
        <S.InputContainer>
          <S.InputStyles
            type="number"
            value={value}
            onChange={(e) => {
              const newValue = Number(e.target.value)

              onChange(newValue)
            }}
            onBlur={(e) => {
              let newValue = Number(e.target.value)

              if (newValue < min) newValue = min
              if (newValue > max) newValue = max

              onChange(newValue)
              setLastValue(newValue)
            }}
            min={min}
            max={max}
          />
          <S.Postfix>{unit}</S.Postfix>
        </S.InputContainer>
      </S.Container>
    </>
  )
}
export const Range = withFormikSupport(RangeComponent)
